var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('top-header',{attrs:{"title":_vm.$t('dataEntry')}}),_c('v-progress-linear',{attrs:{"indeterminate":"","active":_vm.loading}}),_c('v-container',[_c('v-row',[_c('v-col',[_c('meter-data-entry-card',{attrs:{"site-meters":_vm.meters},on:{"add-meter-value":_vm.addMeterValue}})],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }